import { ReactNode } from 'react';

// Paleta alinhada ao legado (emissor.semobguarabira.com.br):
// - verde   → AUTORIZADO / AUTORIZADA
// - vermelho→ CANCELADO / CANCELADA / DENEGADA / ERRO
// - âmbar   → REJEITADO / REJEITADA / INUTILIZADO / INUTILIZADA
// - sky     → PROCESSANDO / TRANSMITINDO / AGUARDANDO (em progresso)
// - slate   → RASCUNHO / ASSINADO / demais "em edição" e OUTROS (fallback)
const MAP: Record<string, string> = {
  autorizada: 'badge-success',
  autorizado: 'badge-success',

  cancelada: 'badge-danger',
  cancelado: 'badge-danger',
  denegada: 'badge-danger',
  denegado: 'badge-danger',
  erro: 'badge-danger',

  rejeitada: 'badge-warning',
  rejeitado: 'badge-warning',
  inutilizada: 'badge-warning',
  inutilizado: 'badge-warning',

  processando: 'badge-info',
  transmitindo: 'badge-info',
  transmitida: 'badge-info',
  transmitido: 'badge-info',
  aguardando: 'badge-info',
  pendente: 'badge-info',

  rascunho: 'badge-neutral',
  editando: 'badge-neutral',
  pronto_assinar: 'badge-neutral',
  assinada: 'badge-neutral',
  assinado: 'badge-neutral',
};

function normalize(status?: string): string {
  if (!status) return '';
  return status.toLowerCase().trim().replace(/\s+/g, '_');
}

function labelize(status?: string): string {
  if (!status) return '?';
  return status.replace(/_/g, ' ');
}

export default function StatusBadge({ status, icon }: { status?: string; icon?: ReactNode }) {
  const key = normalize(status);
  const cls = MAP[key] ?? 'badge-neutral';
  return (
    <span className={cls}>
      {icon}
      {labelize(status)}
    </span>
  );
}
